import type { ServiceFormItem } from './formTypes';
import { normalizeServiceItem } from './usageScenario';

/** 服务配置 API 项（提交字段 usage，非表单 usageScenario） */
export type ServiceApiItem = Omit<ServiceFormItem, 'usageScenario' | '_isDefault'> & {
  usage?: string;
  /** 服务挂载的节点组名称列表 */
  groupNames?: string[];
};

/** 将表单服务项序列化为 API 提交结构（usageScenario → usage） */
export function serializeServiceItemForApi(item: ServiceFormItem): ServiceApiItem {
  const normalized = normalizeServiceItem(item);
  const { usageScenario, _isDefault, ...rest } = normalized;
  const payload: ServiceApiItem = { ...rest };
  if (usageScenario) {
    payload.usage = usageScenario;
  }
  return payload;
}

/** 批量序列化服务列表为 API 提交结构 */
export function serializeServiceListForApi(list: ServiceFormItem[] | undefined | null): ServiceApiItem[] | undefined {
  if (!Array.isArray(list)) return undefined;
  return list.map(serializeServiceItemForApi);
}

/** 将 API / 镜像预置服务项反序列化为表单结构（usage / usageScenario → usageScenario） */
export function deserializeServiceItemFromApi(raw: unknown): ServiceFormItem {
  if (!raw || typeof raw !== 'object') {
    return raw as ServiceFormItem;
  }
  const item = raw as Record<string, unknown>;
  const usageScenario = String(item.usage ?? item.usageScenario ?? '').trim() || undefined;
  const { usage: _usage, usageScenario: _legacyUsageScenario, ...rest } = item;
  return normalizeServiceItem({
    ...(rest as ServiceFormItem),
    usageScenario,
  });
}

/** 批量反序列化 API 服务列表为表单结构 */
export function deserializeServiceListFromApi(list: unknown[] | undefined | null): ServiceFormItem[] | undefined {
  if (!Array.isArray(list)) return undefined;
  return list.map(deserializeServiceItemFromApi);
}
